module.exports = __webpack_public_path__ + "img/remove-icon.6be1b398.svg";